import {ElasticParser, ElasticSearchProperty} from '../factory.parsers';
import {RaDecParserParser} from './ra-dec.parser';

export class TargetListParser implements ElasticParser {
  parseValue(targetListLinesParsed: any, elasticSearchProperty: ElasticSearchProperty): any {
    const raDecParser = new RaDecParserParser();

    const targetListQueries = targetListLinesParsed?.split('|')
      .map(targetListLine => targetListLine.trim())
      .filter(targetListLine => !!targetListLine)
      .map(targetListLine => raDecParser.parseValue(targetListLine, elasticSearchProperty));

    if (targetListQueries?.length > 0) {
      return {bool: {should: targetListQueries}};
    } else {
      return undefined;
    }
  }
}
